import round from 'lodash/round';
import {useCallback, useState} from 'react';
import {requestContext} from '../../../../../../common/requestContext';
import useTypedDispatch from '../../../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {MobileViewerSeekbar} from '../../../../../../design-system/organisms/MobileViewerSeekbar/MobileViewerSeekbar';
import {ViewerType} from '../constant/viewerConstant';
import {
  forceProcessToTalkIndex,
  setIsHandlingSeekBar,
} from '../state/talkViewerSlice';

export function TalkViewerSeekBarContainer({productId}: {productId: number}) {
  const {isMobile} = requestContext.requestInfo.display;
  const dispatch = useTypedDispatch();

  const currentProgress = useTypedSelector(
    state =>
      // 톡뷰어는 기존스펙 유지에 의해 뷰어엔드 접근시 visitedTalkCount가 totalTalkCount를 넘어갑니다. 최대 totalTalkCount까지만 progress계산에 사용합니다.
      Math.min(
        state.talkViewer.productInfoMap[productId].progress.visitedTalkCount,
        state.talkViewer.productInfoMap[productId].progress.totalTalkCount
      ) / state.talkViewer.productInfoMap[productId].progress.totalTalkCount
  );
  const isHandlingSeekBar = useTypedSelector(
    state => state.talkViewer.isHandlingSeekBar
  );
  const [showingProgress, setShowingProgress] = useState(currentProgress);
  const totalTalkCount = useTypedSelector(
    state => state.talkViewer.productInfoMap[productId].progress.totalTalkCount
  );

  const onPressIndicator = useCallback(() => {
    dispatch(setIsHandlingSeekBar(true));
  }, [dispatch]);

  const onChangeProgress = useCallback((newProgress: number) => {
    setShowingProgress(newProgress);
  }, []);

  const onReleaseIndicator = useCallback(() => {
    dispatch(
      forceProcessToTalkIndex(
        Math.max(1, Math.round(showingProgress * totalTalkCount))
      )
    );
    dispatch(setIsHandlingSeekBar(false));
  }, [dispatch, totalTalkCount, showingProgress]);

  return isMobile ? (
    <MobileViewerSeekbar
      viewerType={ViewerType.TalkViewer}
      currentProgress={round(
        isHandlingSeekBar ? showingProgress : currentProgress,
        2
      )}
      loadedProgress={1} // TODO : 로딩에 대한 의사결정 및 처리가 필요합니다
      onPressProgressBar={onPressIndicator}
      onChangeProgress={onChangeProgress}
      onReleaseProgressBar={onReleaseIndicator}
    />
  ) : null;
}
